import { useConnectModal } from '@rainbow-me/rainbowkit'
import { useCallback } from 'react'
import { useDisconnect } from 'wagmi'

import { sleep } from '@/lib/utils'

export default function useLogin() {
  const { disconnectAsync } = useDisconnect()
  const { openConnectModal } = useConnectModal()

  return useCallback(async () => {
    await disconnectAsync()
    await sleep(10)
    openConnectModal?.()
  }, [disconnectAsync, openConnectModal])
}
